(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('slideshow:select', (event) => {
  const gallery = event.target.closest('.card-gallery');
  if (!gallery) return;

  const dots = gallery.querySelectorAll('.card-gallery__dot');
  if (!dots.length) return;

  const active = Math.min(event.detail.index, dots.length - 1);
  dots.forEach((dot, index) => dot.classList.toggle('is-active', index === active));
});
  } catch(e) { console.error(e); }
})();

})();
